import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";

import misionImg from "../../static/media/nosotros/Mision.webp";
import visionImg from "../../static/media/nosotros/Vision.webp";

const C = {
  dark: "#0C1F2F",
  navy: "#0057A8",
  gold: "#FFCD00",
  gray: "#F5F7FA",
  white: "#ffffff",
  darkBlue: "#0C1F2F",
};

const CARDS = [
  {
    title: "Nuestra Misión",
    img: misionImg,
    accent: C.navy,
    text: "ELECTRICAGRM es una empresa innovadora en soluciones de ingeniería y desarrollos eléctricos; confiables, eficientes y éticos, orientada a satisfacer las necesidades y aspiraciones de nuestros clientes desarrollándolas al más alto nivel de excelencia, economía y eficiencia, manteniendo estándares de calidad e integrando nuevos y mejores productos.",
  },
  {
    title: "Nuestra Visión",
    img: visionImg,
    accent: C.gold,
    text: "Constituirnos en una empresa líder de ingeniería, con capacidad para enfrentar nuevos desafíos y aportar soluciones innovadoras y efectivas, que se encuentren dirigidas al crecimiento y desarrollo productivo tanto local como nacional, consolidándonos como un aliado estratégico en búsqueda de la satisfacción del cliente.",
  },
];

export default function MisionVision() {
  return (
    <Box
      sx={{
        background: C.white,
        display: "flex",
        alignItems: "center",
        position: "relative",
        // Reducimos el padding superior para eliminar el espacio sobrante arriba del título
        pt: { xs: "40px", md: "60px" },
        pb: { xs: "20vw", md: "10vw" },
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "1280px",
          mx: "auto",
          px: { xs: 3, md: 5 },
          width: "100%",
          zIndex: 1,
          position: "relative",
        }}
      >
        {/* TÍTULO CENTRADO CON LÍNEA */}
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          sx={{
            mb: { xs: 5, md: 8 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: C.dark,
              fontWeight: 750,
              fontSize: { xs: 28, sm: 34, md: 40 },
              letterSpacing: "-.02em",
              mb: 2,
            }}
          >
            Misión y Visión
          </Typography>
          <Box
            sx={{
              width: "60px",
              height: "3px",
              background: C.navy,
              borderRadius: "2px",
            }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 5,
          }}
        >
          {CARDS.map((card, i) => (
            <Box
              key={card.title}
              component={motion.div}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.2 }}
              sx={{
                flex: 1,
                background: C.white,
                borderRadius: "24px",
                overflow: "hidden",
                border: "1px solid #EAEAEA",
                boxShadow: "0 15px 40px rgba(0,87,168,0.06)",
                display: "flex",
                flexDirection: "column",
                transition: "transform 0.3s",
                "&:hover": { transform: "translateY(-5px)" },
              }}
            >
              <Box sx={{ p: { xs: 4, md: 5 } }}>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 3, mb: 3 }}
                >
                  <Box
                    sx={{
                      width: 68,
                      height: 68,
                      borderRadius: "16px",
                      background: "rgba(0,87,168,0.04)",
                      border: "1px solid rgba(0,87,168,0.08)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Box
                      component="img"
                      src={card.img}
                      alt={card.title}
                      sx={{ width: 44, height: 44, objectFit: "contain" }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      color: C.dark,
                      fontWeight: 750,
                      fontSize: { xs: 18, lg: 20 },
                    }}
                  >
                    {card.title}
                  </Typography>
                </Box>

                <Typography
                  sx={{
                    color: "#4e5f6e",
                    fontSize: "1.05rem",
                    fontWeight: 700,
                    lineHeight: 1.8,
                  }}
                >
                  {card.text}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      {/* CURVA SINUOSA - Conecta hacia NuestroEquipo (Fondo C.darkBlue) */}
      <Box
        sx={{
          position: "absolute",
          bottom: -1,
          left: 0,
          width: "100%",
          overflow: "hidden",
          lineHeight: 0,
          zIndex: 10,
          transform: "translateY(2px)",
        }}
      >
        <svg
          viewBox="0 0 1440 320"
          style={{
            display: "block",
            width: "100%",
            height: "12vw",
            minHeight: "80px",
            transform: "scaleX(-1)",
          }}
          preserveAspectRatio="none"
        >
          <path
            fill={C.darkBlue}
            d="M0,224L80,213.3C160,203,320,181,480,186.7C640,192,800,224,960,218.7C1120,213,1280,171,1360,149.3L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
          ></path>
        </svg>
      </Box>
    </Box>
  );
}
